import permission from './permission'

const install = function(Vue) {
  Vue.directive('permission', permission)
}

if (window.Vue) {
  window.permission = permission
  Vue.use(install)
}

export default install



// WEBPACK FOOTER //
// ./src/directive/index.js